module.exports = __webpack_public_path__ + "static/media/Source Info.b0f9ad3b.txt";